import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status"];
import React from 'react';
import PT from 'prop-types';
import RobotWorried from '@scaleflex/icons/robot-worried';
import RobotSad from '@scaleflex/icons/robot-sad';
import RobotNeutral from '@scaleflex/icons/robot-neutral';
import RobotHappy from '@scaleflex/icons/robot-happy';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { Status } from './types';
import Styled from './robot.styles';

var getRobotIcon = function getRobotIcon(status) {
  switch (status) {
    case Status.Worried:
      return /*#__PURE__*/React.createElement(RobotWorried, null);

    case Status.Sad:
      return /*#__PURE__*/React.createElement(RobotSad, null);

    case Status.Neutral:
      return /*#__PURE__*/React.createElement(RobotNeutral, null);

    case Status.Happy:
    default:
      return /*#__PURE__*/React.createElement(RobotHappy, null);
  }
};

var Robot = intrinsicComponent(function (_ref, ref) {
  var status = _ref.status,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Styled.Robot, _extends({}, rest, {
    ref: ref
  }), getRobotIcon(status));
});
export var defaultProps = {
  status: Status.Happy
};
Robot.defaultProps = defaultProps;
export var propTypes = {
  status: PT.oneOf(objectValues(Status))
};
Robot.propTypes = propTypes;
export default Robot;